<p-drawer
  [(visible)]="visible"
  position="right"
  [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
>
  <div class="p-4">
    <h5>Layout/Theme Scale</h5>
    <div class="flex items-center">
      <button
        icon="pi pi-minus"
        type="button"
        pButton
        (click)="decrementScale()"
        class="mr-2 w-8 h-8 p-button-text p-button-rounded"
        [disabled]="scale === scales[0]"
      ></button>
      <div class="flex gap-2 items-center">
        @for (s of scales; track s) {
          <i
            class="pi pi-circle-fill text-surface-300 dark:text-surface-500"
            [ngClass]="{ 'text-primary-500': s === scale }"
          ></i>
        }
      </div>
      <button
        icon="pi pi-plus"
        type="button"
        pButton
        (click)="incrementScale()"
        class="ml-2 w-8 h-8 p-button-text p-button-rounded"
        [disabled]="scale === scales[scales.length - 1]"
      ></button>
    </div>

    <h5>Color Scheme</h5>
    <div class="flex gap-6">
      <div class="flex-1 field-radiobutton">
        <p-radioButton
          name="colorScheme"
          value="light"
          [(ngModel)]="colorScheme"
          inputId="light"
        ></p-radioButton>
        <label for="light">Light</label>
      </div>
      <div class="flex-1 field-radiobutton">
        <p-radioButton
          name="colorScheme"
          value="dark"
          [(ngModel)]="colorScheme"
          inputId="dark"
        ></p-radioButton>
        <label for="dark">Dark</label>
      </div>
    </div>

    @if (!minimal()) {
      <h5>Menu Mode</h5>
      <div class="flex flex-wrap gap-y-4">
        <div class="flex gap-2 items-center w-6/12">
          <p-radioButton
            name="menuMode"
            value="static"
            [(ngModel)]="menuMode"
            inputId="mode1"
          ></p-radioButton>
          <label for="mode1">Static</label>
        </div>
        <div class="flex gap-2 items-center w-6/12">
          <p-radioButton
            name="menuMode"
            value="overlay"
            [(ngModel)]="menuMode"
            inputId="mode2"
          ></p-radioButton>
          <label for="mode2">Overlay</label>
        </div>
        <div class="flex gap-2 items-center w-6/12">
          <p-radioButton
            name="menuMode"
            value="slim"
            [(ngModel)]="menuMode"
            inputId="mode3"
          ></p-radioButton>
          <label for="mode3">Slim</label>
        </div>
        <div class="flex gap-2 items-center w-6/12">
          <p-radioButton
            name="menuMode"
            value="slim-plus"
            [(ngModel)]="menuMode"
            inputId="mode4"
          ></p-radioButton>
          <label for="mode4">Slim +</label>
        </div>
        <div class="flex gap-2 items-center w-6/12">
          <p-radioButton
            name="menuMode"
            value="reveal"
            [(ngModel)]="menuMode"
            inputId="mode6"
          ></p-radioButton>
          <label for="mode6">Reveal</label>
        </div>
        <div class="flex gap-2 items-center w-6/12">
          <p-radioButton
            name="menuMode"
            value="drawer"
            [(ngModel)]="menuMode"
            inputId="mode7"
          ></p-radioButton>
          <label for="mode7">Drawer</label>
        </div>
        <div class="flex gap-2 items-center w-6/12">
          <p-radioButton
            name="menuMode"
            value="horizontal"
            [(ngModel)]="menuMode"
            inputId="mode5"
          ></p-radioButton>
          <label for="mode5">Horizontal</label>
        </div>
      </div>
      <h5>Menu Profile Position</h5>
      <div class="flex gap-6">
        <div class="flex-1 field-radiobutton">
          <p-radioButton
            name="position"
            value="start"
            [(ngModel)]="menuProfilePosition"
            inputId="start"
          ></p-radioButton>
          <label for="star">Start</label>
        </div>
        <div class="flex-1 field-radiobutton">
          <p-radioButton
            name="position"
            value="end"
            [(ngModel)]="menuProfilePosition"
            inputId="end"
          ></p-radioButton>
          <label for="end">End</label>
        </div>
      </div>
    }

    @if (!minimal()) {
      <h5>Input Style</h5>
      <div class="flex gap-6">
        <div class="flex-1 field-radiobutton">
          <p-radioButton
            name="inputStyle"
            value="outlined"
            [(ngModel)]="inputStyle"
            inputId="outlined_input"
          ></p-radioButton>
          <label for="outlined_input">Outlined</label>
        </div>
        <div class="flex-1 field-radiobutton">
          <p-radioButton
            name="inputStyle"
            value="filled"
            [(ngModel)]="inputStyle"
            inputId="filled_input"
          ></p-radioButton>
          <label for="filled_input">Filled</label>
        </div>
      </div>
    }

    @if (!minimal()) {
      <ng-container
        public
        readonly
        appSubjects="AppSubjects;"
      >
        <h5>Menu Themes</h5>
        @if (colorScheme === 'dark') {
          <p>
            Menu themes are only available in light mode by design as large surfaces can emit too much brightness in
            dark mode.
          </p>
        } @else {
          <div class="flex flex-wrap gap-y-4 pb-4">
            @for (theme of menuThemes; track theme) {
              <div class="w-3/12">
                <button
                  type="button"
                  class="flex justify-center items-center w-8 h-8 rounded-full shadow cursor-pointer p-link rounded-border shrink-0"
                  (click)="changeMenuTheme(theme.name)"
                  [ngStyle]="{ 'background-color': theme.color }"
                >
                  @if (menuTheme === theme.name) {
                    <i
                      class="text-lg pi pi-check"
                      [ngClass]="{ 'text-white': menuTheme !== 'light' }"
                    ></i>
                  }
                </button>
              </div>
            }
          </div>
        }
        <h5>Topbar Themes</h5>
        <div class="flex flex-wrap gap-y-4 pb-4">
          @for (theme of topbarThemes; track theme) {
            <div class="w-3/12">
              <button
                type="button"
                class="flex justify-center items-center w-8 h-8 rounded-full shadow cursor-pointer p-link rounded-border shrink-0"
                (click)="changeTopbarTheme(theme.name)"
                [ngStyle]="{ 'background-color': theme.color }"
              >
                @if (topbarTheme === theme.name) {
                  <i
                    class="text-lg pi pi-check"
                    [ngClass]="{ 'text-white': topbarTheme !== 'white' }"
                  ></i>
                }
              </button>
            </div>
          }
        </div>
      </ng-container>
    }

    <h5>Component Themes</h5>
    <div class="flex flex-wrap gap-y-4">
      @for (theme of componentThemes; track theme) {
        <div class="w-3/12">
          <button
            type="button"
            class="flex justify-center items-center w-8 h-8 rounded-full shadow cursor-pointer p-link rounded-border shrink-0"
            (click)="changeTheme(theme.name)"
            [ngStyle]="{ 'background-color': theme.color }"
          >
            @if (componentTheme === theme.name) {
              <i class="text-lg text-white pi pi-check"></i>
            }
          </button>
        </div>
      }
    </div>
  </div>
</p-drawer>
